import React, { useEffect, useState } from 'react';
import { Input, Spin } from 'antd';
import { postApi } from '../../redux/rest/restSlice';
import { LIST_KIOSK } from '../../constants/actionTypes';
import { unwrapResult } from '@reduxjs/toolkit';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { kioskTables } from '../../constants/kioskTables';
import { TABLE_PAGINATION } from '../../utilities/helper';
import DataTable from '../DataTable';
import SummaryStrip from '../SummaryStrip';

const KioskOverviewTable = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [searchValue, setSearchValue] = useState('');
    const [appliedSearch, setAppliedSearch] = useState('');

    const dispatch = useDispatch();

    const fetchKioskList = (search = '') => {
        const term = (search || '').trim();

        setLoading(true);
        setAppliedSearch(term);
        dispatch(postApi({
            endpoint: LIST_KIOSK,
            payload: {
                filters: term ? { kiosk_id: term } : {},
            },
        }))
            .then(unwrapResult)
            .then((result) => {
                setLoading(false);
                setData(get(result, 'data'));
            })
            .catch(() => {
                setLoading(false);
            })
    };

    useEffect(() => {
        fetchKioskList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const clearSearch = () => {
        setSearchValue('');
        fetchKioskList('');
    };

    const rows = get(data, 'data') || [];
    const firstLoad = loading && !rows.length;
    const online = rows.filter((row) => row.is_online === true).length;

    const summary = rows.length
        ? [
            { label: 'Total', value: rows.length },
            { label: 'Online', value: online, tone: 'success' },
            { label: 'Offline', value: rows.length - online, tone: 'danger' },
            { label: 'Linked', value: rows.filter((row) => row.is_linked === true).length, tone: 'info' },
        ]
        : [];

    return (
        <Spin spinning={loading && !firstLoad}>
            <div className='list-toolbar'>
                <div className='list-toolbar__main'>
                    <Input.Search
                        className='list-toolbar__search'
                        placeholder='Search by Kiosk ID'
                        allowClear
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onSearch={fetchKioskList}
                    />
                </div>
            </div>

            {!firstLoad && <SummaryStrip items={summary} />}

            <DataTable
                skeleton={firstLoad}
                scrollX={500}
                rowKey='id'
                className='mt-20'
                dataSource={rows}
                columns={kioskTables()}
                pagination={TABLE_PAGINATION}
                emptyProps={{
                    noun: 'kiosks',
                    search: appliedSearch,
                    onClearSearch: clearSearch,
                }}
            />
        </Spin>
    );
};

export default KioskOverviewTable;
